import type { ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useT } from '../../i18n';
import { MessagePage } from '../common/MessagePage';

export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const { role } = useApp();
  const t = useT();
  if (role !== 'super_admin') {
    return <MessagePage icon={Lock} title={t('soon.denied')} body={t('soon.deniedBody', { role: t(`roles.${role}`) })} />;
  }
  return <>{children}</>;
}
